import { render, staticRenderFns } from "./HomeVendor.vue?vue&type=template&id=b09c69f6&scoped=true"
import script from "./HomeVendor.vue?vue&type=script&lang=ts"
export * from "./HomeVendor.vue?vue&type=script&lang=ts"
import style0 from "./HomeVendor.vue?vue&type=style&index=0&id=b09c69f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c69f6",
  null
  
)

export default component.exports